import React, { useState } from "react"
import axios from "axios"
import Input from "components/Input"
import Checkbox from "components/Checkbox"
import Button from "components/Button"
import { Formik } from "formik"
import * as Yup from "yup"
import { useLocale } from "context/locale"

import StyledNewsletterForm from "./styles"

const NewsletterForm = () => {
  const [status, setStatus] = useState(null)
  const { t } = useLocale()
  return (
    <StyledNewsletterForm>
      <div className="newsletter-header">
        <p className="title bolder">{t("Sign up to our newsletter")}</p>
        <p className="desc">{t("And let us inspire you!")}</p>
      </div>
      {status === "success" ? (
        <div className="newsletter-status">
          <p className="bolder">
            {t(
              "Thank you for subscribing to our newsletter. Check your inbox to find out what's next!"
            )}
          </p>
        </div>
      ) : status === "failure" ? (
        <div className="newsletter-status">
          <p className="bolder">
            {t("An error occurred. Please try again later.")}
          </p>
        </div>
      ) : (
        <Formik
          initialValues={{ email: "", legal: false, legal_second: false }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .email(t("Invalid email"))
              .required(t("E-mail is required")),
            legal: Yup.bool().oneOf([true], t("Required field")),
            legal_second: Yup.bool().oneOf([true], t("Required field")),
          })}
          onSubmit={async ({ email }, { setSubmitting }) => {
            try {
              let formData = new FormData()
              formData.set("newsletter_email", email)
              await axios.post(process.env.GATSBY_NEWSLETTER_ENDPOINT, formData)
              setStatus("success")
            } catch (error) {
              setStatus("failure")
            } finally {
              setSubmitting(false)
            }
          }}
        >
          {({ handleSubmit, isSubmitting }) => (
            <form
              noValidate
              onSubmit={handleSubmit}
              className="newsletter-form"
            >
              <div className="newsletter-form__wrapper">
                <Input
                  theme="white"
                  type="email"
                  name="email"
                  label={t("Your e-mail")}
                />
                <Button
                  text={t("Join")}
                  theme="white"
                  type="submit"
                  disabled={isSubmitting}
                />
              </div>
              <Checkbox
                name="legal"
                label={t(
                  "I agree to receive commercial correspondence in the form of a newsletter to the e-mail address I provided."
                )}
                color="white"
              />
              <Checkbox
                name="legal_second"
                label={t(
                  "I accept the <a href='/en/service-rules/' target='_blank'>website regulations</a> and consent to the processing of personal data in accordance with GDPR."
                )}
                color="white"
              />
            </form>
          )}
        </Formik>
      )}
    </StyledNewsletterForm>
  )
}

export default NewsletterForm
